import { I18n } from "i18n-js";
import translations from "../../translations.json";

// Create a single shared I18n instance
const i18n = new I18n(translations);

// Set default locale
i18n.defaultLocale = "en";

// Set locale from document or default to English
i18n.locale = document.documentElement.lang || "en";

export default i18n;
